import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  userList,
  customerSelect,
  userImpersonate,
  setAuthToken,
  setProfile,
  userGet,
  resetReducersOnImpersonate,
  usersReset,
  getSoftwareUpdate
} from '../../redux/actions'
import {getAppSetting} from '../../redux/actions/appSettingActions'

import {
  defaultPager
} from '../../common/tabletools'

import history from '../../history'
import Organisation from '../../components/organisation'
import NoData from '../../components/nodata'


import Auth from '../../auth'

import {
  preparePager,
  prepareSearch
} from '../../common/tabletools'

const auth = new Auth()

class OrganisationPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      pager: {
        defaultColumns: ['firstname', 'lastname', 'customer_name'],
        manual: true,
        pageno: 1,
        pagesize: 5,
        order: {},
        search: [],
        global: false
      }
    }
  }

  componentWillMount() {
    this.props.start(this.props.match.params.cid)
  }

  getUsers = (table) => {
    const { getUsers, selectedCustomer } = this.props
    const { pager } = this.state
    if (!pager.global) {
      getUsers(table ? preparePager(table, pager) : pager, selectedCustomer.id)
    }
  }

  render() {

    const {
      translate,
      selectedCustomer,
      users,
      getUsers,
      impersonationRequest,
      languages
    } = this.props

    const {
      pager
    } = this.state

    if (selectedCustomer) {
      return (
        <Organisation
          selectedCustomer={selectedCustomer}
          translate={translate}
          users={users}
          getUsers={this.getUsers}
          pager={pager}
          impersonationRequest={impersonationRequest}
          languages={languages}
        />
      )
    } else {
      return <NoData translate={translate} />
    }

  }

  componentWillUnmount() {
    this.props.usersReset()
  }

}

const mapStateToProps = (state) => ({
  selectedCustomer: state.customerReducer.customer,
  users: state.userReducer.users,
  ...state,
})

const mapDispatchToProps = (dispatch, props) => ({
  start: (cid) => {
    dispatch(customerSelect(cid))
  },
  getUsers: (pager, cid = null) => {
    return new Promise((resolve, reject) => {
      dispatch(userList(pager, cid, props)).then(() => {
        resolve()
      })
    })
  },
  impersonationRequest: (request) => {
    dispatch(userImpersonate(request)).then((response) => {
      let data = response.payload.data
      const {
        access_token,
        impersonatedname,
        impersonatedcustomer,
        impersonatedroles,
        impersonatedrolenames,
        impersonateduserid,
        impersonatedcustomerid,
        refresh_token
      } = data

      let expires = (new Date(response.payload.data['.expires'])).getTime()
      dispatch(setAuthToken({
        access_token,
        refresh_token,
        expires
      }))
      auth.handleAuthentication({
        access_token,
        refresh_token,
        expires: expires
      })

      dispatch(setProfile({
        roles: impersonatedroles,
        id: impersonateduserid,
        customerid: impersonatedcustomerid,
        customer: impersonatedcustomer,
        name: impersonatedname,
        rolenames: impersonatedrolenames
      }))
      dispatch(userGet(impersonateduserid, true))

      history.replace('/jobs', true)
      dispatch(resetReducersOnImpersonate());

      dispatch(getSoftwareUpdate());
      dispatch(getAppSetting({ force: true }));

    })
  },
  usersReset: () => {
    dispatch(usersReset())
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationPage)
